import React, { useState } from 'react'
import Headerone from '../headerone/newMain'
import Bredcom from '../Bredcom/Main'

function AnnualReports() {
    return (
        <>
            <Headerone />
            <Bredcom title="Home" subtitle="Annual Reports" />
            <section className="about-area about-p pt-60 pb-60 p-relative fix">
          <div className="container">
            <h2 class="text-center"> Annual Reports</h2>
            <br/>

            <table class="table table-bordered">
    <thead class="table-light head_red">
        <tr>
            <th scope="col">Sr. No.</th>
            <th scope="col">Name</th>
            <th scope="col">Link</th>
        </tr>
    </thead>
    <tbody>
        {/* <tr>
            <td>1</td>
            <td>Annual Report BS FY 2023-24</td>
            <td><a href="/annual-report-BS-FY-2023-24.pdf" target='_blank' >View </a></td>
        </tr> */}
         
    </tbody>
</table>




          </div>
          
        </section>
        </>
    )
}

export default AnnualReports